/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Subtract_Frame_From_StartInputs */



/**
* | output |
* | --- |
* | "Subtract 1 Frame From Start" |
*
* @param {Shortcut_Keys_Name_Subtract_Frame_From_StartInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_subtract_frame_from_start = /** @type {((inputs?: Shortcut_Keys_Name_Subtract_Frame_From_StartInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Subtract_Frame_From_StartInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Soustraire 1 image au debut")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ziehe 1 Frame vom Start ab")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sottrai 1 fotogramma dall'inizio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вычтите 1 кадр из начального значения.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Restar 1 fotograma del inicio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("从起始帧减去 1 帧")
	if (locale === "ja") return /** @type {LocalizedString} */ ("開始から1フレーム減算")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शुरुआत से 1 फ्रेम घटाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Subtraia 1 quadro do início.")
	return /** @type {LocalizedString} */ ("Subtract 1 Frame From Start")
});